module.exports = __webpack_public_path__ + "8fb81b515d86144337bcf4a469298fc8.svg";